export default "__VITE_ASSET__DqE7Buru__"